import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type SaveButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
};

const SaveButton = ({
    label = "Save",
    loadingText = "Saving...",
    buttonType = "submit",
    ...props
}: SaveButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="save"
            testId="save-button"
            buttonType={buttonType}
            {...props}
        />
    );
};

export default SaveButton;
